<template>
  <div class="phone-container">
    <div class="phone-content">
      <input
        :type="validateStrategy.type"
        :placeholder="placeholder"
        @blur="blur"
        @focus="validateError = false"
        v-model="account"
        @input="debounceInput"
        :maxlength="validateStrategy.maxLength"
        :readonly="!phoneInputDisabled"
      />
    </div>
    <i
      class="icon"
      @click="clear()"
      v-if="account && phoneInputDisabled"
    />
    <p
      class="phone-desc"
      v-if="showError && account"
    >
      {{ validateStrategy.errorTip }}
    </p>
  </div>
</template>

<script>
  import {validator} from './validate'
  import {debounce, getSessionCache} from '@/utils';
  import {mapGetters} from 'vuex'

  export default {
    name: 'Account',
    props: {
      accountType: {
        type: String,
        validator(type) {
          return ['phoneNum', 'char', 'qq'].includes(type)
        },
        default: 'phoneNum'
      }
      , placeholder: {
        type: String,
        default: ''
      }
      , phoneInputDisabled: {
        type: Boolean
      }
    },
    computed: {
      ...mapGetters({
        user: 'user' // 用户信息
      })
      , showError() {
        return this.validateError && this.validateStrategy.errorTip
      }
    },
    data() {
      return {
        account: '',
        validateError: false,
        validateStrategy: null
      }
    },
    mounted() {
      let cacheAccountTemporary = getSessionCache('cacheAccountTemporary')
      let cacheAccount = this.user.phoneNum
      // 取缓存号码
      if (cacheAccountTemporary) { // 为了微信刷新界面所使用
        this.account = cacheAccountTemporary
        this.check()
      } else if (cacheAccount && this.accountType === 'phoneNum') {
        this.account = cacheAccount
        this.check()
      } else {
        this.account = ''
      }
    },
    methods: {
      check() {
        try {
          this.validateStrategy = validator[this.accountType]
          this.blur()
        } catch (e) {
          throw new Error('platform account validate config error')
        }
      },
      blur() {
        if (this.account) {
          if (this.validateStrategy.validateFunc) {
            this.validateError = !this.validateStrategy.validateFunc(this.account)
          }
          if (this.account.length > this.validateStrategy.maxLength) {
            this.account = this.account.substr(0, this.validateStrategy.maxLength)
          }
          this.$emit('getAccount', this.validateError ? '' : this.account)
        }
      },
      debounceInput: debounce(function (e) {
        this.account = this.validateStrategy.filter(this.account)
        if (this.account) {
          if (this.validateStrategy.validateFunc) {
            if (this.validateStrategy.validateFunc(this.account)) {
              this.validateError = false
              const isPhoneWillBlur = this.accountType === 'phoneNum'
              if (isPhoneWillBlur) {
                e.target.blur()
              }
            }
          }
        } else {
          this.validateError = false
        }
      }, 320),
      clear() {
        this.account = ''
        this.$emit('getAccount', '')
      }
    },
    watch: {
      accountType: {
        handler: 'check',
        immediate: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/common";

  .phone-container {
    @include content-box;
    padding: 20px 20px;
    position: relative;
    .phone-content {
      padding: 10px;
      input {
        width: 100%;
        height: 100%;
        padding: 10px 100px 10px 0;
        font-size: 45px;
        color: #222;
        border: none;
        outline: none;
        &::placeholder {
          color: #bbb;
        }
      }
    }
    .icon {
      width: 100px;
      height: 100px;
      display: inline-block;
      position: absolute;
      right: 20px;
      top: 50%;
      margin-top: -50px;
      background: url('../../assets/image/close.png') center no-repeat;
      background-size: 50%;
    }
    .phone-desc {
      font-size: 36px;
      color: red;
      position: absolute;
      bottom: 20px;
      left: 40px;
    }
  }
</style>
